<div class="copright_text"> Copyright ©
    <a href="javascript:void(0);">2023</a> All
    Rights Reserved.<br></div>